'use client'

import dynamic from 'next/dynamic'
import { useEffect, useState } from 'react'

const CookieConsent = dynamic(() => import('@/components/CookieConsent'), {
  ssr: false,
})

export default function DeferredCookieConsent() {
  const [ready, setReady] = useState(false)

  useEffect(() => {
    const win = window as Window & {
      requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => number
      cancelIdleCallback?: (id: number) => void
    }

    let timeoutId: number | null = null
    let idleId: number | null = null
    const show = () => setReady(true)

    if (typeof win.requestIdleCallback === 'function') {
      idleId = win.requestIdleCallback(show, { timeout: 3000 })
    } else {
      timeoutId = window.setTimeout(show, 2200)
    }

    return () => {
      if (idleId !== null && typeof win.cancelIdleCallback === 'function')
        win.cancelIdleCallback(idleId)
      if (timeoutId !== null) window.clearTimeout(timeoutId)
    }
  }, [])

  if (!ready) return null
  return <CookieConsent />
}
